import React, { useCallback, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import {
  CButton,
  CCard,
  CCardBody,
  CCol,
  CContainer,
  CForm,
  CInput,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CRow,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import { errorAlert, successAlert } from "../components/utils/messages";
import { resetPassword } from "../redux/actions/user";

interface ResetPasswordParams {
  token: string;
}

const ResetPassword = () => {
  const history = useHistory();
  const { token } = useParams<ResetPasswordParams>();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(async () => {
    if (!password || !confirmPassword) {
      errorAlert("Por favor completa todos los campos");
      return;
    }

    if (password !== confirmPassword) {
      errorAlert("Las contraseñas no coinciden");
      return;
    }

    if (password.length < 6) {
      errorAlert("La contraseña debe tener al menos 6 caracteres");
      return;
    }

    setLoading(true);
    try {
      const success = await resetPassword(token, password);
      if (success) {
        successAlert("Contraseña actualizada exitosamente");
        // Redirigir al login después de 2 segundos
        setTimeout(() => {
          history.push("/login");
        }, 2000);
      } else {
        errorAlert("Token inválido o expirado");
      }
    } catch (error) {
      errorAlert("Error al restablecer la contraseña");
    } finally {
      setLoading(false);
    }
  }, [password, confirmPassword, token, history]);

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setConfirmPassword(e.target.value);
  };

  return (
    <div className="c-app c-default-layout flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md="6">
            <CCard className="p-4">
              <CCardBody>
                <CForm>
                  <h1>Nueva Contraseña</h1>
                  <p className="text-muted">Ingresa tu nueva contraseña</p>
                  <CInputGroup className="mb-3">
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <CIcon name="cil-lock-locked" />
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <CInput
                      type="password"
                      placeholder="Nueva Contraseña"
                      autoComplete="new-password"
                      onChange={handlePasswordChange}
                      value={password}
                      disabled={loading}
                    />
                  </CInputGroup>
                  <CInputGroup className="mb-4">
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <CIcon name="cil-lock-locked" />
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <CInput
                      type="password"
                      placeholder="Confirmar Contraseña"
                      autoComplete="new-password"
                      onChange={handleConfirmPasswordChange}
                      value={confirmPassword}
                      disabled={loading}
                    />
                  </CInputGroup>
                  <CRow>
                    <CCol xs="12">
                      <CButton
                        color="primary"
                        className="px-4"
                        onClick={handleSubmit}
                        disabled={loading}
                        block
                      >
                        {loading ? "Actualizando..." : "Actualizar Contraseña"}
                      </CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

export default ResetPassword;
